import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Message from '../../components/ui/Message';
import { costingApi } from './costing';

// Configuración del inventario del comercio: inventario negativo y fecha de cierre.
// El método de costeo es fijo: costo promedio ponderado móvil.
export const InventorySettingsPage = () => {
    const navigate = useNavigate();
    const [allowNegative, setAllowNegative] = useState(true);
    const [closingDate, setClosingDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        costingApi.configuration().then((r) => {
            setLoading(false);
            if (!r.data) return setError(r.error!);
            setAllowNegative(r.data.configuration.allowNegative);
            setClosingDate(r.data.configuration.closingDate ?? '');
        });
    }, []);

    const save = async () => {
        setSaving(true);
        const resp = await costingApi.saveConfiguration({ allowNegative, closingDate: closingDate || null });
        setSaving(false);
        if (resp.error) setError(resp.error);
        else setSuccess('Se guardó la configuración del inventario.');
    };

    return (
        <div className='container d-flex justify-content-center mt-5'>
            <div className='col-md-7'>
                <h3>Configuración del inventario</h3>
                <p className="text-muted">El inventario se valoriza con costo promedio ponderado: cada compra recalcula el costo y las salidas salen a ese costo.</p>
                <hr />
                {loading ? (
                    <div className="text-center py-4"><span className="spinner-border spinner-border-sm me-2" /> Cargando...</div>
                ) : (
                    <>
                        <div className="form-check form-switch mb-1">
                            <input id="allowNegativeSwitch" className="form-check-input" type="checkbox" checked={allowNegative} onChange={(e) => setAllowNegative(e.target.checked)} />
                            <label htmlFor="allowNegativeSwitch" className="form-check-label">Permitir inventario negativo</label>
                        </div>
                        <p className="form-text mb-4">
                            Permitido, una salida sin existencia sale al último costo promedio y el producto aparece en la alerta de negativos.
                            Bloqueado, las salidas manuales, traslados y reversiones sin existencia se rechazan. Las ventas nunca se bloquean para no detener la caja.
                        </p>

                        <label htmlFor="closingDateInput" className="form-label">Inventario cerrado hasta</label>
                        <input id="closingDateInput" type="date" className="form-control" style={{ maxWidth: 220 }} value={closingDate} onChange={(e) => setClosingDate(e.target.value)} />
                        <p className="form-text">No se aceptan movimientos ni reversiones con fecha igual o anterior. Déjelo vacío si no hay período cerrado.</p>

                        <div className='d-flex justify-content-center gap-3 mt-4'>
                            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate('/stocks')}>Atrás</button>
                            <button type="button" className="btn btn-primary" onClick={save} disabled={saving}>Guardar</button>
                        </div>
                    </>
                )}
            </div>
            {error && <Message type="error" message={error} closeDialog={() => setError('')} handleOk={() => setError('')} backgroundColor="rgba(0,0,0,0.4)" />}
            {success && <Message type="success" title="Exitoso" message={success} closeDialog={() => navigate('/stocks')} handleOk={() => navigate('/stocks')} backgroundColor="rgba(0,0,0,0.4)" />}
        </div>
    );
};
